var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Type } from 'class-transformer';
import { Column, CreateDateColumn, Entity, Index, JoinColumn, ManyToOne, PrimaryColumn, Unique, UpdateDateColumn } from 'typeorm';
let Root = class Root {
    id;
    createdDate;
    updatedDate;
    hostname;
    project;
    projectId;
};
__decorate([
    PrimaryColumn('uuid', { default: () => 'uuidv7()' }),
    __metadata("design:type", String)
], Root.prototype, "id", void 0);
__decorate([
    CreateDateColumn({ type: 'timestamptz' }),
    Type(() => Date),
    __metadata("design:type", Date)
], Root.prototype, "createdDate", void 0);
__decorate([
    UpdateDateColumn({ type: 'timestamptz' }),
    Type(() => Date),
    __metadata("design:type", Date)
], Root.prototype, "updatedDate", void 0);
__decorate([
    Column(),
    __metadata("design:type", String)
], Root.prototype, "hostname", void 0);
__decorate([
    Index(),
    ManyToOne('Project', (project) => project.roots, { nullable: false, onDelete: 'CASCADE' }),
    JoinColumn({ name: 'projectId' }),
    __metadata("design:type", Function)
], Root.prototype, "project", void 0);
__decorate([
    Column('uuid'),
    __metadata("design:type", String)
], Root.prototype, "projectId", void 0);
Root = __decorate([
    Entity(),
    Unique(['projectId', 'hostname'])
], Root);
export { Root };
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicm9vdC5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9kb21haW4vbW9kZWxzL3Jvb3QudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7O0FBQUEsT0FBTyxFQUFFLElBQUksRUFBRSxNQUFNLG1CQUFtQixDQUFDO0FBQ3pDLE9BQU8sRUFDTCxNQUFNLEVBQ04sZ0JBQWdCLEVBQ2hCLE1BQU0sRUFDTixLQUFLLEVBQ0wsVUFBVSxFQUNWLFNBQVMsRUFDVCxhQUFhLEVBQ2IsTUFBTSxFQUNOLGdCQUFnQixFQUNqQixNQUFNLFNBQVMsQ0FBQztBQUtWLElBQU0sSUFBSSxHQUFWLE1BQU0sSUFBSTtJQUVmLEVBQUUsQ0FBVTtJQUlaLFdBQVcsQ0FBUTtJQUluQixXQUFXLENBQVE7SUFHbkIsUUFBUSxDQUFVO0lBS2xCLE9BQU8sQ0FBVztJQUdsQixTQUFTLENBQVU7Q0FDcEIsQ0FBQTtBQXBCQztJQURDLGFBQWEsQ0FBQyxNQUFNLEVBQUUsRUFBRSxPQUFPLEVBQUUsR0FBRyxFQUFFLENBQUMsVUFBVSxFQUFFLENBQUM7O2dDQUN6QztBQUlaO0lBRkMsZ0JBQWdCLENBQUMsRUFBRSxJQUFJLEVBQUUsYUFBYSxFQUFFLENBQUM7SUFDekMsSUFBSSxDQUFDLEdBQUcsRUFBRSxDQUFDLElBQUksQ0FBQzs4QkFDSCxJQUFJO3lDQUFDO0FBSW5CO0lBRkMsZ0JBQWdCLENBQUMsRUFBRSxJQUFJLEVBQUUsYUFBYSxFQUFFLENBQUM7SUFDekMsSUFBSSxDQUFDLEdBQUcsRUFBRSxDQUFDLElBQUksQ0FBQzs4QkFDSCxJQUFJO3lDQUFDO0FBR25CO0lBREMsTUFBTSxFQUFFOztzQ0FDUztBQUtsQjtJQUhDLEtBQUssRUFBRTtJQUNQLFNBQVMsQ0FBQyxTQUFTLEVBQUUsQ0FBQyxPQUFnQixFQUFFLEVBQUUsQ0FBQyxPQUFPLENBQUMsS0FBSyxFQUFFLEVBQUUsUUFBUSxFQUFFLEtBQUssRUFBRSxRQUFRLEVBQUUsU0FBUyxFQUFFLENBQUM7SUFDbkcsVUFBVSxDQUFDLEVBQUUsSUFBSSxFQUFFLFdBQVcsRUFBRSxDQUFDOztxQ0FDaEI7QUFHbEI7SUFEQyxNQUFNLENBQUMsTUFBTSxDQUFDOzt1Q0FDSTtBQXJCUixJQUFJO0lBRmhCLE1BQU0sRUFBRTtJQUNSLE1BQU0sQ0FBQyxDQUFDLFdBQVcsRUFBRSxVQUFVLENBQUMsQ0FBQztHQUNyQixJQUFJLENBc0JoQiJ9